/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetadataPropertyDto } from './MetadataPropertyDto';
import {
    MetadataPropertyDtoFromJSON,
    MetadataPropertyDtoFromJSONTyped,
    MetadataPropertyDtoToJSON,
    MetadataPropertyDtoToJSONTyped,
} from './MetadataPropertyDto';

/**
 * 
 * @export
 * @interface POAMMetadataDto
 */
export interface POAMMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof POAMMetadataDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMMetadataDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMMetadataDto
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMMetadataDto
     */
    published?: Date;
    /**
     * 
     * @type {Date}
     * @memberof POAMMetadataDto
     */
    lastModified?: Date;
    /**
     * 
     * @type {string}
     * @memberof POAMMetadataDto
     */
    remarks?: string;
    /**
     * 
     * @type {Array<MetadataPropertyDto>}
     * @memberof POAMMetadataDto
     */
    props?: Array<MetadataPropertyDto>;
}

/**
 * Check if a given object implements the POAMMetadataDto interface.
 */
export function instanceOfPOAMMetadataDto(value: object): value is POAMMetadataDto {
    return true;
}

export function POAMMetadataDtoFromJSON(json: any): POAMMetadataDto {
    return POAMMetadataDtoFromJSONTyped(json, false);
}

export function POAMMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'published': json['published'] == null ? undefined : (new Date(json['published'])),
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(MetadataPropertyDtoFromJSON)),
    };
}

export function POAMMetadataDtoToJSON(json: any): POAMMetadataDto {
    return POAMMetadataDtoToJSONTyped(json, false);
}

export function POAMMetadataDtoToJSONTyped(value?: POAMMetadataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'published': value['published'] == null ? undefined : ((value['published']).toISOString()),
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString()),
        'remarks': value['remarks'],
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(MetadataPropertyDtoToJSON)),
    };
}

